/**
 * ElevenLabs Service - Voice cloning and TTS (now routes through User Backend)
 * 
 * This service maintains backward compatibility with existing components
 * while routing all AI requests through the secure User Backend.
 * 
 * NO API KEYS IN FRONTEND - all generation goes through:
 * Frontend → User Backend → Admin Backend → ElevenLabs
 */

import * as aiService from './aiService';

// Legacy storage key - kept for backward compatibility but no longer used
export const ELEVENLABS_API_KEY_STORAGE_KEY = 'loopai-adstudio-elevenlabs-api-key-v2';

/**
 * Clone a voice using ElevenLabs (via secure backend)
 */
export const cloneVoiceWithElevenLabs = async (name, audioDataUri) => {
    const result = await aiService.cloneVoice(name, audioDataUri);
    return result.voiceId;
};

/**
 * Generate speech using ElevenLabs TTS (via secure backend)
 */
export const generateSpeechWithElevenLabs = async (text, voiceId) => {
    const result = await aiService.generateSpeech(text, voiceId);
    
    // Return audio as data URI for backward compatibility
    if (result.audioData) {
        return result.audioData;
    }
    
    // If we got a URL, fetch and convert to data URI
    if (result.audioUrl) {
        try {
            const response = await fetch(result.audioUrl, { credentials: 'include' });
            const blob = await response.blob();
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        } catch (e) {
            console.error('Failed to convert audio URL to data URI:', e);
            throw e;
        }
    }
    
    throw new Error('No audio data received');
};

/**
 * Get available voices from ElevenLabs (via secure backend)
 */
export const getElevenLabsVoices = async () => {
    return aiService.getVoices();
};

// ==================== DEPRECATED / NO-OP FUNCTIONS ====================

// These functions are no longer needed as API keys are managed server-side
export const getElevenLabsApiKey = () => {
    console.warn('API keys are now managed server-side.');
    return 'managed-server-side';
};
